export enum DimensionPrecision {
  FOOT = "FOOT",
  INCH = "INCH",
  PRECISION_1_2 = "PRECISION_1_2",
  PRECISION_1_4 = "PRECISION_1_4",
  PRECISION_1_8 = "PRECISION_1_8",
  PRECISION_1_16 = "PRECISION_1_16",
  PRECISION_1_32 = "PRECISION_1_32",
  PRECISION_1_64 = "PRECISION_1_64",
}

export const DimensionPrecisionDisplay: { [key in DimensionPrecision]: string } = {
  [DimensionPrecision.FOOT]: "1'",
  [DimensionPrecision.INCH]: '1"',
  [DimensionPrecision.PRECISION_1_2]: '1/2"',
  [DimensionPrecision.PRECISION_1_4]: '1/4"',
  [DimensionPrecision.PRECISION_1_8]: '1/8"',
  [DimensionPrecision.PRECISION_1_16]: '1/16"',
  [DimensionPrecision.PRECISION_1_32]: '1/32"',
  [DimensionPrecision.PRECISION_1_64]: '1/64"',
};

export const DimensionPrecisionDenominator: { [key in DimensionPrecision]: number | undefined } = {
  [DimensionPrecision.FOOT]: undefined,
  [DimensionPrecision.INCH]: 1,
  [DimensionPrecision.PRECISION_1_2]: 2,
  [DimensionPrecision.PRECISION_1_4]: 4,
  [DimensionPrecision.PRECISION_1_8]: 8,
  [DimensionPrecision.PRECISION_1_16]: 16,
  [DimensionPrecision.PRECISION_1_32]: 32,
  [DimensionPrecision.PRECISION_1_64]: 64,
};
